import { ToolCallItem } from './ToolCallItem';
import type { ToolCall } from '@/types/chat';

interface ToolCallListProps {
  tools: ToolCall[];
}

export function ToolCallList({ tools }: ToolCallListProps) {
  if (tools.length === 0) {
    return (
      <p className="text-sm text-muted-foreground py-2">
        Nenhuma tool chamada
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {tools.map((tool, i) => (
        <ToolCallItem key={`${tool.endpoint}-${tool.method}-${i}`} toolCall={tool} index={i + 1} />
      ))}
    </div>
  );
}
